// extracted by mini-css-extract-plugin
export default {"google_translate_element":"GoogleTranslateButton_google_translate_element__RYJ1L","borderBox":"GoogleTranslateButton_borderBox__K8zl-","box":"GoogleTranslateButton_box__AnDLI"};